export function getManualNameFromRoleId(roleId: number): string {
  switch (roleId) {
    case 10:
      return 'Manuale_Ruolo_Proponente_QRSP.pdf';
    case 11:
      return 'Manuale_Ruolo_Regione_QRSP.pdf';
    case 12:
      return 'Manuale_Ruolo_Regione_QRSP.pdf';
    case 13:
      return 'Manuale_Ruolo_Regione_QRSP.pdf';
    default:
      return 'Cruscotto_QRSP.pdf';
  }
}
